import * as CONST from "./actionTypes";

export const documentsList = (payload, callBack) => {
  return {
    type: CONST.DOCUMENTS_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const documentsList_Success = (payload) => ({
  type: CONST.DOCUMENTS_LIST_SUCCESS,
  payload,
});

export const documentsList_Fail = (payload) => ({
  type: CONST.DOCUMENTS_LIST_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> EDIT DOCUMENTS >>>>>>>>>>>>>>>*/
export const editDocuments = (payload, callBack) => {
  return {
    type: CONST.EDIT_DOCUMENTS,
    payload: payload,
    callBack,
  };
};

export const editDocuments_Success = (payload) => ({
  type: CONST.EDIT_DOCUMENTS_SUCCESS,
  payload,
});

export const editDocuments_Fail = (payload) => ({
  type: CONST.EDIT_DOCUMENTS_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> UPDATE DOCUMENTS >>>>>>>>>>>>>>>*/

export const updateDocuments = (payload, callBack) => {
  return {
    type: CONST.UPDATE_DOCUMENTS,
    payload: { ...payload },
    callBack,
  };
};

export const updateDocuments_Success = (payload) => ({
  type: CONST.UPDATE_DOCUMENTS_SUCCESS,
  payload,
});

export const updateDocuments_Fail = (payload) => ({
  type: CONST.UPDATE_DOCUMENTS_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> ADD DOCUMENTS >>>>>>>>>>>>>>>*/

export const addDocuments = (payload, callBack) => {
  return {
    type: CONST.ADD_DOCUMENTS,
    payload: { ...payload },
    callBack,
  };
};

export const addDocuments_Success = (payload) => ({
  type: CONST.ADD_DOCUMENTS_SUCCESS,
  payload,
});

export const addDocuments_Fail = (payload) => ({
  type: CONST.ADD_DOCUMENTS_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> BLOCK_UNBLOCK USER >>>>>>>>>>>>>>>*/

// export const blockUnblockUser = (payload, callBack) => {
//   return {
//     type: CONST.BLOCK_UNBLOCK_USER,
//     payload: { ...payload },
//     callBack,
//   };
// };

// export const blockUnblockUser_Success = (payload) => ({
//   type: CONST.BLOCK_UNBLOCK_USER_SUCCESS,
//   payload,
// });

// export const blockUnblockUser_Fail = (payload) => ({
//   type: CONST.BLOCK_UNBLOCK_USER_FAIL,
//   payload,
// });

/* >>>>>>>>>>>>>> DELETE DOCUMENTS >>>>>>>>>>>>>>>*/

export const deleteDocuments = (payload, callBack) => {
  return {
    type: CONST.DELETE_DOCUMENTS,
    payload: { ...payload },
    callBack,
  };
};

export const deleteDocuments_Success = (payload) => ({
  type: CONST.DELETE_DOCUMENTS_SUCCESS,
  payload,
});

export const deleteDocuments_Fail = (payload) => ({
  type: CONST.DELETE_DOCUMENTS_FAIL,
  payload,
});
